
import React from 'react'
import AboutUsHero from '../components/aboutUS/AboutUsHero'
import Overview from '../components/aboutUS/Overview'
import AboutClasses from '../components/aboutUS/AboutClasses'
import Accomplishment from '../components/aboutUS/Accomplishment'
import AboutGurusPage from './AboutOurGuru'



const AboutUs = () => {
  return (
  <div>
    <AboutUsHero/>
    <Overview/>
    <AboutGurusPage/>
    <AboutClasses/>
    <Accomplishment/>
  </div>
  )
}

export default AboutUs